import { BOOKING_STATUS, MEMBERSHIP_LEVELS } from "../constants/enums";
import { TABLE_STATUS } from "../constants/enums";

export const translateTableStatus = (translator, status) => {
  switch (status) {
    case TABLE_STATUS.IN_SERVICE:
      return translator("status.table.in_service");
    case TABLE_STATUS.AVAILABLE:
      return translator("status.table.available");
    case TABLE_STATUS.OUT_OF_SERVICE:
      return translator("status.table.out_of_service");
    default:
      return status;
  }
};

export const translateBookingStatus = (translator, status) => {
  switch (status) {
    case BOOKING_STATUS.CONFIRMED:
      return translator("status.booking.confirmed");
    case BOOKING_STATUS.PENDING:
      return translator("status.booking.pending");
    case BOOKING_STATUS.COMPLETED:
      return translator("status.booking.completed");
    case BOOKING_STATUS.CANCELLED:
      return translator("status.booking.cancelled");
    default:
      return status;
  }
};

export const translateMembershipLevel = (translator, level) => {
  switch (level) {
    case MEMBERSHIP_LEVELS.REGULAR:
      return translator("membership.levels.regular");
    case MEMBERSHIP_LEVELS.SILVER:
      return translator("membership.levels.silver");
    case MEMBERSHIP_LEVELS.GOLD:
      return translator("membership.levels.gold");
    case MEMBERSHIP_LEVELS.PLATINUM:
      return translator("membership.levels.platinum");
    default:
      return level;
  }
};
